import React from 'react'
import {
  useHistory
} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';
import Snackbar from '@material-ui/core/Snackbar';
import { CheckCircleRounded } from '@material-ui/icons';


import Config from '../config';
import AdminHeaderDrawer from '../AdminHeaderDrawer';
// import { checkMobileNumber, formatMobileNumber } from './utils';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
  },
  header: {
    textAlign: 'center',
  },
  form: {

    '& > *': {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    textAlign: 'center',
    minWidth: 280,
    maxWidth: 340,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    // marginTop: theme.spacing(4),
    marginTop: 110,

  },
  formControl: {
    width: 300,
    backgroundColor: '#FFF',
  },
  otpButton: {
    color: '#666',
    marginTop: theme.spacing(1),
    backgroundColor: '#FFF',
  },
  button: {
    width: 300,
    height: 56,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(3),
    // color: 'white',
    fontSize: 18,
  },
  title: {
    flexGrow: 1,
  },
}));

const ChangePassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const [password, setPassword] = React.useState<string>('');
  const [confirmPassword, setConfirmPassword] = React.useState<string>('');

  const [verifyCode, setVerifyCode] = React.useState<string>('');
  const [count, setCount] = React.useState(0);
  const [isRunning, setIsRunning] = React.useState(false);

  const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>();
  const [changePasswordCompleted, setChangePasswordCompleted] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!localStorage.getItem('accessToken') || !localStorage.getItem('storeId')) history.push('/login');
  }, []);

  const handleSubmit = () => {
    if (!password.trim() || !confirmPassword.trim() || !verifyCode.trim()) {
      setErrorMessage('Please enter all required information');
      setSnackbarOpen(true);
      return;
    }

    if (password.trim().length < 6) {
      setErrorMessage('Password must be at least 6 characters');
      setSnackbarOpen(true);
      return;
    }

    if (password.trim() !== confirmPassword.trim()) {
      setErrorMessage('Please enter same password');
      setSnackbarOpen(true);
      return;
    }
    updatePassword();
  };

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const updatePassword = async () => {
    try {
      const res = await fetch(`${Config.apiUrl}account/update-password`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('accessToken') || '',
            otp: verifyCode || '',
          },
          body: JSON.stringify({
            password: password.trim(),
          })
        }
      );
      if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
      }
      setChangePasswordCompleted(true)
      // setErrorMessage('Change Password Success!');
      // setSnackbarOpen(true);
    } catch (error) {
      console.error(error.message)
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  };

  const handleSendVerifyCode = async () => {
    try {

      const profileRes = await fetch(`${Config.apiUrl}account/`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('accessToken') || '',
          },
        }
      );
      if (!profileRes.ok) {
        const message = `An error has occured: ${profileRes.status}`;
        throw new Error(message);
      }

      const profile = await profileRes.json();
      if (!profile.mobile) {
        setErrorMessage('An error has occured: Missing valid mobile number');
        setSnackbarOpen(true);
        return;
      }


      const res = await fetch(`${Config.apiUrl}account/manage/otp-request/mobile`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('accessToken') || '',
          },
          body: JSON.stringify({
            mobile: profile.mobile,
          })
        }
      );
      if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
      }
      setErrorMessage('Sent successfully! Verify Code has been sent to your mobile.');
      setSnackbarOpen(true);
      setCount(30);
      setIsRunning(true);
    } catch (error) {
      console.error(error.message)
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  };

  useInterval(() => {
    setCount(count - 1);
    if (count === 0) setIsRunning(false);
  }, isRunning ? 1000 : null);


  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <AdminHeaderDrawer />
          <Typography variant="h6" className={classes.title}>
            Change Password
          </Typography>
        </Toolbar>
      </AppBar>

      {changePasswordCompleted ?
        <div className={classes.form}>
          <CheckCircleRounded htmlColor='#0DDD7E' style={{ fontSize: 150, marginBottom: 20, marginTop: 30, }} />
          <Typography variant="h6" component="p" style={{ color: 'black', marginTop: 20, marginBottom: 20 }} >
            Change Password Success!
            </Typography>
            <Button
              onClick={() => history.goBack()}
              variant="contained"
              color="primary"
              disableElevation
              // size="large"
              className={classes.button}
            >
              Back
            </Button>
        </div>
        : null}

      {!changePasswordCompleted ?
        <div className={classes.form}>
          <TextField
            color="secondary"
            fullWidth
            className={classes.formControl}
            type="password"
            autoComplete="new-password"
            required id="password"
            label="New Password"
            variant="outlined"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <TextField
            color="secondary"
            fullWidth
            className={classes.formControl}
            type="password"
            required id="confirmPassword"
            label="Confirm New Password"
            variant="outlined"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
          />
          <TextField
            color="secondary"
            type="number"
            fullWidth
            className={classes.formControl}
            // autoComplete="tel"
            required id="verifyCode"
            label="Verify Code"
            variant="outlined"
            value={verifyCode}
            onChange={e => setVerifyCode(e.target.value)}
          />
          <Button className={classes.otpButton} disabled={count > 0} onClick={handleSendVerifyCode} variant="outlined" >
            {count > 0 && `(${count}) `}Get Verification Code
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disableElevation
            size="large"
            className={classes.button}
          >
            Submit
        </Button>
          {/* <Typography variant="caption" component="p" style={{ textAlign: 'center', marginTop: 10, }} >
          © {moment().format('YYYY')} Link Tech, Inc. All rights reserved.
        </Typography> */}
        </div>
        : null}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        message={errorMessage}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setSnackbarOpen(false)}>
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

    </div>
  );
};

function useInterval(callback: Function, delay: any) {
  const savedCallback = React.useRef<any>();

  // Remember the latest function.
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  React.useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default ChangePassword;